export default "__VITE_ASSET__C2YwtEEl__"